import { INVOICE_REPORT_STATUSES, type DateRangeReportKind } from "../../shared/reporting";
import { currentCalendarDate } from "../../shared/calendar-date";

export interface ReportingPeriod { from: string; to: string }
export interface ReportFilterFields extends ReportingPeriod { client: string; status: string }
export function currentReportingYear(): ReportingPeriod {
  const year = currentCalendarDate().slice(0, 4);
  return {from: `${year}-01-01`, to: `${year}-12-31`};
}
export function periodQuery(period: ReportingPeriod) { return new URLSearchParams({from: period.from, to: period.to}).toString(); }
export function validReportingDate(value: string) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value) || value.startsWith("0000")) return false;
  const date = new Date(`${value}T00:00:00Z`);
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value;
}
export function reportingPeriodError(period: ReportingPeriod) {
  if (!validReportingDate(period.from) || !validReportingDate(period.to)) return "Enter a complete, valid From and To date.";
  return period.from > period.to ? "From must be on or before To." : "";
}
export function reportFilterFields(search: string): ReportFilterFields {
  const params = new URLSearchParams(search), defaults = currentReportingYear();
  return {from: params.get("from") ?? defaults.from, to: params.get("to") ?? defaults.to, client: params.get("client") ?? "all", status: params.get("status") ?? "all"};
}
export function reportFilterError(kind: DateRangeReportKind, fields: ReportFilterFields) {
  if (reportingPeriodError(fields)) return reportingPeriodError(fields);
  if (kind !== "revenue-by-client" && fields.client !== "all" && !/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(fields.client)) return "Choose a valid client.";
  if (kind === "invoice-details" && fields.status !== "all" && !INVOICE_REPORT_STATUSES.some(status => status === fields.status)) return "Choose a supported Invoice status.";
  return "";
}
export function reportFilterQuery(kind: DateRangeReportKind, fields: ReportFilterFields) {
  const params = new URLSearchParams({from: fields.from, to: fields.to});
  if (kind !== "revenue-by-client") params.set("client", fields.client);
  if (kind === "invoice-details") params.set("status", fields.status);
  return params.toString();
}
